function n(e) {
  setTimeout(e, 1);
}
var r = function(t) {
  return t && "current" in t ? t.current : t;
};
export {
  n as deferAction,
  r as extractRef
};
//# sourceMappingURL=util.js.map
